// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"373":"b19e44d1","835":"9f58b39e"}[chunkId] + ".chunk.css";
};